import React, { useState } from 'react';
import API_URL from '../config';

const STORAGE_KEY = 'consultor_token';

export default function ConsultorLoginPage() {
  const [login, setLogin] = useState('');
  const [senha, setSenha] = useState('');
  const [showSenha, setShowSenha] = useState(false);
  const [erro, setErro] = useState('');
  const [carregando, setCarregando] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErro('');
    setCarregando(true);
    try {
      const res = await fetch(`${API_URL}/api/consultor/auth/login`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ login: login.trim(), senha }),
      });
      if (!res.ok) {
        const body = await res.json().catch(() => ({}));
        throw new Error(body.detail || 'Credenciais inválidas');
      }
      const data = await res.json();
      localStorage.setItem(STORAGE_KEY, data.token);
      window.location.replace('/portal-consultor');
    } catch (err) {
      setErro(err.message);
    } finally {
      setCarregando(false);
    }
  };

  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
      fontFamily: "'Inter', sans-serif",
      padding: '1rem',
    }}>
      <div style={{
        background: '#fff',
        borderRadius: '16px',
        padding: '2.5rem 2rem',
        width: '100%',
        maxWidth: '420px',
        boxShadow: '0 20px 60px rgba(0,0,0,0.2)',
      }}>
        <div style={{ textAlign: 'center', marginBottom: '2rem' }}>
          <div style={{
            width: 52, height: 52,
            borderRadius: '12px',
            background: 'linear-gradient(135deg, #667eea, #764ba2)',
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'center',
            marginBottom: '1rem',
          }}>
            <span className="material-symbols-outlined" style={{ color: '#fff', fontSize: 28 }}>handshake</span>
          </div>
          <h1 style={{ fontSize: '1.5rem', fontWeight: 700, color: '#1e293b', margin: 0 }}>
            Portal do Consultor
          </h1>
          <p style={{ color: '#64748b', marginTop: '0.5rem', fontSize: '0.9rem' }}>
            Acesso exclusivo para consultores parceiros Qaa.sa
          </p>
        </div>

        <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
          <div>
            <label style={{ fontSize: '0.85rem', fontWeight: 600, color: '#374151', display: 'block', marginBottom: '0.4rem' }}>
              E-mail ou código
            </label>
            <div style={{ position: 'relative' }}>
              <span className="material-symbols-outlined" style={{
                position: 'absolute', left: '12px', top: '50%', transform: 'translateY(-50%)',
                color: '#9ca3af', fontSize: '20px',
              }}>person</span>
              <input
                type="text"
                value={login}
                onChange={(e) => setLogin(e.target.value)}
                required
                disabled={carregando}
                placeholder="parceiro@empresa.com.br ou QS-AB01"
                style={{
                  width: '100%', boxSizing: 'border-box',
                  padding: '0.75rem 0.75rem 0.75rem 2.75rem',
                  border: '1.5px solid #e2e8f0', borderRadius: '10px',
                  fontSize: '0.95rem', outline: 'none',
                  transition: 'border-color .15s',
                }}
              />
            </div>
          </div>

          <div>
            <label style={{ fontSize: '0.85rem', fontWeight: 600, color: '#374151', display: 'block', marginBottom: '0.4rem' }}>
              Senha
            </label>
            <div style={{ position: 'relative' }}>
              <span className="material-symbols-outlined" style={{
                position: 'absolute', left: '12px', top: '50%', transform: 'translateY(-50%)',
                color: '#9ca3af', fontSize: '20px',
              }}>lock</span>
              <input
                type={showSenha ? 'text' : 'password'}
                value={senha}
                onChange={(e) => setSenha(e.target.value)}
                required
                disabled={carregando}
                placeholder="••••••••"
                style={{
                  width: '100%', boxSizing: 'border-box',
                  padding: '0.75rem 2.75rem 0.75rem 2.75rem',
                  border: '1.5px solid #e2e8f0', borderRadius: '10px',
                  fontSize: '0.95rem', outline: 'none',
                }}
              />
              <button type="button" onClick={() => setShowSenha((v) => !v)} style={{
                position: 'absolute', right: '10px', top: '50%', transform: 'translateY(-50%)',
                background: 'none', border: 'none', cursor: 'pointer', color: '#9ca3af', padding: 0,
              }}>
                <span className="material-symbols-outlined" style={{ fontSize: '20px' }}>
                  {showSenha ? 'visibility_off' : 'visibility'}
                </span>
              </button>
            </div>
          </div>

          {erro && (
            <div style={{
              padding: '0.75rem 1rem',
              background: '#fef2f2', border: '1px solid #fecaca', borderRadius: '8px',
              color: '#dc2626', fontSize: '0.875rem',
              display: 'flex', alignItems: 'flex-start', gap: '0.5rem',
            }}>
              <span className="material-symbols-outlined" style={{ fontSize: '18px', flexShrink: 0 }}>error</span>
              {erro}
            </div>
          )}

          <button type="submit" disabled={carregando} style={{
            background: carregando ? '#a5b4fc' : 'linear-gradient(135deg, #667eea, #764ba2)',
            color: '#fff', border: 'none', borderRadius: '10px',
            padding: '0.875rem', fontSize: '0.95rem', fontWeight: 600,
            cursor: carregando ? 'not-allowed' : 'pointer',
            display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '0.5rem',
            marginTop: '0.25rem',
          }}>
            {carregando ? 'Entrando...' : 'Entrar'}
            {!carregando && <span className="material-symbols-outlined" style={{ fontSize: '20px' }}>arrow_forward</span>}
          </button>
        </form>

        <p style={{ textAlign: 'center', marginTop: '1.5rem', fontSize: '0.8rem', color: '#94a3b8' }}>
          Acesso restrito a consultores parceiros Qaa.sa.<br/>
          Para solicitar credenciais, entre em contato com a Qaa.sa.
        </p>
      </div>
    </div>
  );
}
